module.exports = __webpack_public_path__ + "static/img/head-menu-bg-select-129.7d9b2555.png";